import React from "react";
import { ToggleButtonGroup, ToggleButton } from "react-bootstrap";
import { FaIcon } from "lib/FaIcon";

export const ViewModeToggleButtons = ({ viewMode, setViewMode, className = "mb-1" }) => {
  return (
    <ToggleButtonGroup
      name="options"
      defaultValue={"tiles"}
      value={viewMode}
      onChange={setViewMode}
      className={className}
    >
      <ToggleButton value={"Tiles"} variant="light border" size="sm">
        <FaIcon icon="fas fa-grip-vertical fa-lg" mr="mr-0" align=""></FaIcon>
      </ToggleButton>

      <ToggleButton value={"List"} variant="light border" size="sm">
        <FaIcon icon="fas fa-list-ul fa-lg" mr="mr-0" align=""></FaIcon>
      </ToggleButton>
    </ToggleButtonGroup>
  );
};
